module.exports = __webpack_public_path__ + "static/media/pizzeria_carlos.b8809b00.png";